const KEY = "help.pendingCourseAction";
const LIFETIME_MS = 15 * 60 * 1000;
export const MAX_REVIEW_DRAFT_LENGTH = 2000;

const validCourseId = (id) => /^[a-f\d]{24}$/i.test(id || "");
const validPath = (path, courseId) => {
  if (typeof path !== "string" || path.length > 300 || !path.startsWith("/")) return false;
  try {
    const url = new URL(path, "https://help.invalid");
    return url.origin === "https://help.invalid" && url.pathname === `/courses/${courseId}`;
  } catch { return false; }
};

export const clearPendingCourseAction = () => {
  try { localStorage.removeItem(KEY); } catch { /* Storage may be disabled. */ }
};

export const readPendingCourseAction = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const item = JSON.parse(raw);
    if (!item || !["like", "review", "start"].includes(item.action) ||
        !validCourseId(item.courseId) || !validPath(item.returnPath, item.courseId) ||
        !Number.isFinite(item.expiresAt) || item.expiresAt <= Date.now() ||
        item.expiresAt > Date.now() + LIFETIME_MS ||
        (item.action === "review" &&
          (typeof item.draft?.content !== "string" ||
           item.draft.content.length > MAX_REVIEW_DRAFT_LENGTH ||
           !Number.isInteger(item.draft.rating) || item.draft.rating < 1 || item.draft.rating > 5))) {
      clearPendingCourseAction();
      return null;
    }
    return item;
  } catch {
    clearPendingCourseAction();
    return null;
  }
};

export const savePendingCourseAction = ({ action, courseId, returnPath, draft }) => {
  if (!["like", "review", "start"].includes(action) || !validCourseId(courseId) ||
      !validPath(returnPath, courseId)) return false;
  const item = { action, courseId, returnPath, expiresAt: Date.now() + LIFETIME_MS };
  if (action === "review") item.draft = {
    content: String(draft?.content || "").slice(0, MAX_REVIEW_DRAFT_LENGTH),
    rating: Math.max(1, Math.min(5, Number(draft?.rating) || 1)),
  };
  try { localStorage.setItem(KEY, JSON.stringify(item)); return true; }
  catch { return false; }
};

export const pendingCourseReturnPath = () => readPendingCourseAction()?.returnPath || null;

export const takePendingLike = (courseId) => {
  const item = readPendingCourseAction();
  if (!item || item.action !== "like" || item.courseId !== courseId) return false;
  clearPendingCourseAction();
  return true;
};
